const safetyItems = [
  {
    icon: 'ri-shield-user-line',
    title: '18+ Doğrulama',
    desc: 'Platforma giriş için yaş onayı zorunludur. Tüm kullanıcıların 18 yaşından büyük olduğunu beyan etmesi gerekir.',
    color: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/20',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Anlık Raporlama',
    desc: 'Uygunsuz davranış mı gördün? Tek tıkla raporla. Moderasyon ekibimiz 7/24 aktif.',
    color: 'text-violet-400 bg-violet-500/10 border-violet-500/20',
  },
  {
    icon: 'ri-user-forbid-line',
    title: 'Engelleme Sistemi',
    desc: 'İstemediğin birisini anında engelle. Engellenmiş kullanıcılar sana hiçbir zaman tekrar eşleşemez.',
    color: 'text-rose-400 bg-rose-500/10 border-rose-500/20',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'AI Moderasyon',
    desc: 'Yapay zeka destekli moderasyon sistemi, uygunsuz içerikleri otomatik olarak tespit eder ve engeller.',
    color: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20',
  },
];

const SafetySection = () => {
  return (
    <section id="safety" className="py-24 md:py-32 bg-[#060810] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-[600px] h-[300px] rounded-full bg-violet-600/5 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/25 text-emerald-400 text-xs font-semibold mb-6">
              <i className="ri-shield-line" />
              Güvenlik & Gizlilik
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
              Güvenliğin Bizim
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400">
                Önceliğimiz
              </span>
            </h2>
            <p className="text-white/45 text-base leading-relaxed mb-8">
              ChatNow'da her sohbet, çok katmanlı güvenlik sistemi tarafından korunur. Misafir kullanıcıdan kayıtlı üyeye kadar herkes için aynı yüksek güvenlik standardı geçerlidir.
            </p>

            <div className="flex flex-col gap-4">
              {safetyItems.map((item) => (
                <div
                  key={item.title}
                  className={`flex items-start gap-4 p-4 rounded-xl border ${item.color} backdrop-blur-sm`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${item.color}`}>
                    <i className={`${item.icon} text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm mb-1">{item.title}</h4>
                    <p className="text-white/45 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Visual */}
          <div className="relative hidden lg:block">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-emerald-500/10 via-cyan-500/5 to-violet-500/10 blur-xl" />
            <div className="relative bg-[#0d1117]/80 backdrop-blur-xl rounded-3xl border border-white/8 p-8">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-500/20 border border-emerald-500/30">
                  <i className="ri-shield-line text-emerald-400 text-xl" />
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Güvenlik Merkezi</div>
                  <div className="text-emerald-400 text-xs">Tüm sistemler aktif</div>
                </div>
                <div className="ml-auto">
                  <span className="flex items-center gap-1.5 text-xs text-emerald-400">
                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse inline-block" />
                    Canlı
                  </span>
                </div>
              </div>

              {/* Security metrics */}
              {[
                { label: 'AI Moderasyon Doğruluğu', value: 99.2, color: 'bg-emerald-500' },
                { label: 'Raporlara Yanıt Süresi', value: 92, color: 'bg-cyan-500' },
                { label: 'Sahte Hesap Engelleme', value: 97, color: 'bg-violet-500' },
                { label: 'Kullanıcı Memnuniyeti', value: 96, color: 'bg-teal-500' },
              ].map((metric) => (
                <div key={metric.label} className="mb-5">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white/60 text-xs">{metric.label}</span>
                    <span className="text-white font-bold text-sm">{metric.value}%</span>
                  </div>
                  <div className="w-full h-1.5 rounded-full bg-white/5">
                    <div
                      className={`h-full rounded-full ${metric.color}`}
                      style={{ width: `${metric.value}%` }}
                    />
                  </div>
                </div>
              ))}

              <div className="mt-8 pt-6 border-t border-white/5 grid grid-cols-3 gap-4">
                {[
                  { num: '24/7', label: 'Moderasyon' },
                  { num: '<2dk', label: 'Yanıt Süresi' },
                  { num: '0', label: 'Veri Satışı' },
                ].map((s) => (
                  <div key={s.label} className="text-center">
                    <div className="text-white font-extrabold text-lg">{s.num}</div>
                    <div className="text-white/35 text-xs mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafetySection;
